import { object, string } from 'yup';

import { CasinoAdForm } from './form';

import { AdModel } from 'v2/types/AdModel';

export const ACTIVE_AREA_AD_KEY_PREFIX = 'active_area';
export const ACTIVE_AREA_MAX_ADDITIONAL_VALUE_LENGTH = 14;

export const isActiveAreaAdKey = (key: string | undefined): boolean => {
  return !!key && key.startsWith(ACTIVE_AREA_AD_KEY_PREFIX);
};

export const getActiveAreaAdMaxAdditionalValueLength = (adKey: string | undefined): number | undefined => {
  return isActiveAreaAdKey(adKey) ? ACTIVE_AREA_MAX_ADDITIONAL_VALUE_LENGTH : undefined;
};

export const getValidationSchema = (ads: AdModel[] | undefined) => {
  return object({
    name: string().trim().required('Name is required'),
    adId: string().trim().required('Ad is required'),
    casinoId: string().trim().required('Casino is required'),
    additionalValue: string()
      .trim()
      .test(
        'active-area-max-length',
        `Value must be at most ${ACTIVE_AREA_MAX_ADDITIONAL_VALUE_LENGTH} characters for ${ACTIVE_AREA_AD_KEY_PREFIX} ads`,
        function (value) {
          const { adId } = this.parent as CasinoAdForm;
          const adKey = ads?.find((ad) => ad.id === adId)?.key;

          if (!isActiveAreaAdKey(adKey)) return true;

          return (value ?? '').length <= ACTIVE_AREA_MAX_ADDITIONAL_VALUE_LENGTH;
        }
      ),
  });
};
